import { isPhoneInHolidayMode } from "@faire/help-center-self-serve/utils/isSupportServiceInHolidayMode";
import { getIsLoggedInUser } from "@faire/help-center-utils/serialized-data/getUser";
import { useQuery as usePhoneAccessControl } from "@faire/web-api/api/help-center/phone/access_control/get-hooks";
export var usePhoneAuthorization = function usePhoneAuthorization() {
  var _data$has_phone;
  var _usePhoneAccessContro = usePhoneAccessControl({
      enabled: getIsLoggedInUser()
    }),
    data = _usePhoneAccessContro.data;
  var hasPhoneAccess = (_data$has_phone = data === null || data === void 0 ? void 0 : data.has_phone) !== null && _data$has_phone !== void 0 ? _data$has_phone : false;
  if (isPhoneInHolidayMode()) {
    return {
      hasPhoneAccess: false
    };
  }
  return {
    hasPhoneAccess: hasPhoneAccess
  };
};